import React from 'react';
import SettlementListByBrandWrap from '../../views/settlement/components/SettlementListByBrandWrap';

const BalanceBrandListContainer = () => {
  return <SettlementListByBrandWrap />;
};

export default BalanceBrandListContainer;
